import { __commonJS, __toESM } from "./chunk-B4qE4VCv.mjs";
import { require_string } from "./string-rCt3O9BL.mjs";
import { z } from "./dist-gYzkAC94.mjs";
import { require_Option } from "./Option-D1XhUpjC.mjs";
import { isObject } from "./isObject-BT3avPK2.mjs";
import { isArray_default } from "./isArray-CeTKVOa4.mjs";

//#region node_modules/.deno/fp-ts@2.16.10/node_modules/fp-ts/lib/number.js
var require_number = /* @__PURE__ */ __commonJS({ "node_modules/.deno/fp-ts@2.16.10/node_modules/fp-ts/lib/number.js": ((exports) => {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.Field = exports.MonoidProduct = exports.MonoidSum = exports.SemigroupProduct = exports.SemigroupSum = exports.MagmaSub = exports.Show = exports.Bounded = exports.Ord = exports.Eq = exports.isNumber = void 0;
	/**
	* @category refinements
	* @since 2.11.0
	*/
	var isNumber$1 = function(u) {
		return typeof u === "number";
	};
	exports.isNumber = isNumber$1;
	/**
	* @category instances
	* @since 2.10.0
	*/
	exports.Eq = { equals: function(first, second) {
		return first === second;
	} };
	/**
	* @category instances
	* @since 2.10.0
	*/
	exports.Ord = {
		equals: exports.Eq.equals,
		compare: function(first, second) {
			return first < second ? -1 : first > second ? 1 : 0;
		}
	};
	/**
	* @category instances
	* @since 2.10.0
	*/
	exports.Bounded = {
		equals: exports.Eq.equals,
		compare: exports.Ord.compare,
		top: Infinity,
		bottom: -Infinity
	};
	/**
	* @category instances
	* @since 2.10.0
	*/
	exports.Show = { show: function(n) {
		return JSON.stringify(n);
	} };
	/**
	* @category instances
	* @since 2.11.0
	*/
	exports.MagmaSub = { concat: function(first, second) {
		return first - second;
	} };
	/**
	* `number` semigroup under addition.
	*
	* @example
	* import { SemigroupSum } from 'fp-ts/number'
	*
	* assert.deepStrictEqual(SemigroupSum.concat(2, 3), 5)
	*
	* @category instances
	* @since 2.10.0
	*/
	exports.SemigroupSum = { concat: function(first, second) {
		return first + second;
	} };
	/**
	* `number` semigroup under multiplication.
	*
	* @example
	* import { SemigroupProduct } from 'fp-ts/number'
	*
	* assert.deepStrictEqual(SemigroupProduct.concat(2, 3), 6)
	*
	* @category instances
	* @since 2.10.0
	*/
	exports.SemigroupProduct = { concat: function(first, second) {
		return first * second;
	} };
	/**
	* `number` monoid under addition.
	*
	* The `empty` value is `0`.
	*
	* @example
	* import { MonoidSum } from 'fp-ts/number'
	*
	* assert.deepStrictEqual(MonoidSum.concat(2, MonoidSum.empty), 2)
	*
	* @category instances
	* @since 2.10.0
	*/
	exports.MonoidSum = {
		concat: exports.SemigroupSum.concat,
		empty: 0
	};
	/**
	* `number` monoid under multiplication.
	*
	* The `empty` value is `1`.
	*
	* @example
	* import { MonoidProduct } from 'fp-ts/number'
	*
	* assert.deepStrictEqual(MonoidProduct.concat(2, MonoidProduct.empty), 2)
	*
	* @category instances
	* @since 2.10.0
	*/
	exports.MonoidProduct = {
		concat: exports.SemigroupProduct.concat,
		empty: 1
	};
	/**
	* @category instances
	* @since 2.10.0
	*/
	exports.Field = {
		add: exports.SemigroupSum.concat,
		zero: 0,
		mul: exports.SemigroupProduct.concat,
		one: 1,
		sub: exports.MagmaSub.concat,
		degree: function(_) {
			return 1;
		},
		div: function(first, second) {
			return first / second;
		},
		mod: function(first, second) {
			return first % second;
		}
	};
}) });

//#endregion
//#region src/fromEmpty.ts
var import_Option = /* @__PURE__ */ __toESM(require_Option());
var import_number = /* @__PURE__ */ __toESM(require_number());
var import_string = /* @__PURE__ */ __toESM(require_string());
function fromEmpty(t) {
	return z(t).when(Number.isNaN, () => import_Option.none).when(import_number.isNumber, import_Option.fromNullable).when(import_string.isString, (str) => str === "" ? import_Option.none : import_Option.fromNullable(str)).when(isObject, (obj) => Object.keys(obj || {}).length === 0 ? import_Option.none : import_Option.fromNullable(obj)).when(isArray_default, (array) => array.length === 0 ? import_Option.none : import_Option.fromNullable(array)).otherwise((x) => import_Option.fromNullable(x));
}

//#endregion
export { fromEmpty };